import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Grid, Link } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { BasicInput, Tip } from '@dev/ee-components';

import { isCustomBranding } from '@/services/Secuirty';
import { links } from '@/services/dictionaries/links';
import { useCampaignScreensPathsChecker } from '@/components/CampaignCreator/hooks/useCampaignScreensPathsChecker';
import { CampaignErrorNames } from '@/store/campaignCreator/types';
import { getCampainCreatorStore, ModifyCampaignMap, VerifyCampaign } from '@/store/campaignCreator/actions';
import { INDEX_PLACEHOLDER } from '@/services/constants';
import { CampaignSubjectType } from '../../SubjectAndContentInterface';
import { CustomizeSubject } from './components/CustomizeSubject';
import { useGetCampaignInfo } from '../../../hooks/useGetCampaignInfo';
import { TipWrapper } from '../styledComponents';

export const CampaignSubject = (props: CampaignSubjectType): JSX.Element => {
    const { id } = props;
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { isDetailsScreen } = useCampaignScreensPathsChecker();
    const { activeTemplateIndex, errors } = useSelector(getCampainCreatorStore);
    const { subject } = useGetCampaignInfo();

    const subjecErrorName = CampaignErrorNames.CAMPAIGN_TEMPLATES_BODY_SUBJECT.replace(
        INDEX_PLACEHOLDER,
        `${activeTemplateIndex}`
    );
    const subjectHasError = !!errors?.[subjecErrorName];

    const handleSubjectChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
        const modifyMap = new Map<string, any>();
        modifyMap.set(`CampaignTemplates[${activeTemplateIndex}].Body.Subject`, event.currentTarget.value);
        dispatch(ModifyCampaignMap(modifyMap));

        subjectHasError && dispatch(VerifyCampaign());
    };

    return (
        <Grid container xs={12} justifyContent="space-between" style={{ marginTop: 24 }}>
            <Grid item xs>
                <BasicInput
                    id={id}
                    label={t('subject')}
                    value={subject}
                    onChange={handleSubjectChange}
                    endIcon={!isDetailsScreen && <CustomizeSubject />}
                    style={{ paddingRight: 140 }}
                    error={subjectHasError}
                    errorMessage={t('thisfieldisrequired')}
                    readOnly={isDetailsScreen}
                />
            </Grid>

            {!isDetailsScreen && (
                <TipWrapper>
                    <Tip id="subject-customization-tip">
                        {isCustomBranding() ? (
                            t('subjectcustomization')
                        ) : (
                            <Trans
                                i18nKey="subjectcustomizationwithlink"
                                components={{ url: <Link href={links.mergeTags} target="_blank" /> }}
                            />
                        )}
                    </Tip>
                </TipWrapper>
            )}
        </Grid>
    );
};
